import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar                from './components/Navbar';
import Hero                  from './components/Hero';
import Leistungen            from './components/Leistungen';
import Kooperationspartner   from './components/Kooperationspartner';
import MietinteresseSection  from './components/MietinteresseSection';
import KontaktSection        from './components/KontaktSection';
import Footer                from './components/Footer';
import ImpressumPage         from './pages/ImpressumPage';

function HomePage() {
  return (
    <>
      <Hero />
      <Leistungen />
      <Kooperationspartner />
      <MietinteresseSection />
      <KontaktSection />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <div className="app-wrapper">
        <Navbar />
        <main>
          <Routes>
            <Route path="/"          element={<HomePage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
